"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.UnableToParsePayload = exports.ActionNotImplemented = exports.UnsupportedRequestVerion = exports.makeHostHandler = exports.HostHandler = exports.RequestHandler = void 0;
class RequestHandler {
}
exports.RequestHandler = RequestHandler;
class HostHandler {
}
exports.HostHandler = HostHandler;
function makeHostHandler() {
    return new RequestHandlerImp();
}
exports.makeHostHandler = makeHostHandler;
class RequestHandlerImp extends HostHandler {
    constructor() {
        super(...arguments);
        this.handlers = new Map();
        this.handler = (request) => {
            const handler = this.handlers.get(request.type);
            if (!handler) {
                console.warn(`[HostHandler] Unsupported request type recieved: ${request.type}`);
                return;
            }
            try {
                handler.handleRequest(request.version, request.payload);
            }
            catch (e) {
                console.warn(`[HostHandler] ${e}`);
            }
        };
        this.registerRequestHandler = (handler) => {
            if (this.handlers.has(handler.requestType)) {
                console.warn(`[HostHandler] More than one handler is being registered for ${handler.requestType}. Previous handler is being overwritten`);
            }
            this.handlers.set(handler.requestType, handler);
        };
    }
}
class UnsupportedRequestVerion extends Error {
    constructor(requestType, version) {
        const msg = `Version ${version} of request type ${requestType} is not supported`;
        super(msg);
    }
}
exports.UnsupportedRequestVerion = UnsupportedRequestVerion;
class ActionNotImplemented extends Error {
    constructor(requestType) {
        const msg = `Action for request type ${requestType} is not implemented`;
        super(msg);
    }
}
exports.ActionNotImplemented = ActionNotImplemented;
class UnableToParsePayload extends Error {
    constructor(requestType, version, payload) {
        const msg = `Unable to parse paylod for version ${version} of request type ${requestType}: ${payload}`;
        super(msg);
    }
}
exports.UnableToParsePayload = UnableToParsePayload;
